export default {"src":"/_next/static/media/Prometheus.3e59d17b.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};